<template>
    <v-textarea
        class="mt-3"
        :label="$t('vvtProcessEditor.risk.similarProcessingActivity.similarActivityDescription.label')"
        :hint="$t('vvtProcessEditor.risk.similarProcessingActivity.similarActivityDescription.hint')"
        v-model="model"
        auto-grow
        persistent-hint
        filled
        background-color="transparent"
        spellcheck="true"
        :disabled="disabled"
    />
</template>

<script>
import Debounceable from '@/components/Debounceable';

export default {
    name: 'VvtRiskSimilarProcessingActivityDescription',
    mixins: [Debounceable],
    props: {
        formScope: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    i18n: {
        messages: {
            en: require('@/locales/vvt/ProcessEditor/en.json'),
            de: require('@/locales/vvt/ProcessEditor/de.json'),
        },
    },
};
</script>
